<template>
  <div class="fill-height"
    :style="[
      {'background-image': `url('${require('@/assets/background-login.jpg')}')`},
      {'background-repeat': 'repeat'}
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh">
      <div style="max-height:100%; overflow:auto">
        <v-container>
          <div style="color:white;font-size:45px;font-weight:500;">
            Status
          </div>
          <cards-list :is-loading-distributors="isLoadingDistributors"></cards-list>

          <distributors-details
            :is-loading-distributors="isLoadingDistributors"
          ></distributors-details>
        </v-container>

      </div>

    </v-main>

    <v-speed-dial
      id="supervisedashboard-speed-dial"
      class="strategio-speed-dial"
      fixed
      v-model="fab"
      bottom
      right
      direction="top"
      transition="scale-transition"
      v-if="isAdmin"
    >
      <v-btn
        slot="activator"
        color="primary"
        fab
        class="elevation-6"
        v-model="fab"
        :loading="isLoadingDistributors"
      >
        <v-icon>settings</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-tooltip left>
        <v-btn
          fab
          small
          color="white"
          slot="activator"
          :disabled="isLoadingDistributors"
          @click="listDistributors"
        >
          <v-icon style="font-size:26px" color="grey darken-1">business</v-icon>
        </v-btn>
        <span>Administrar dist.</span>
      </v-tooltip>
      <v-tooltip left>
        <v-btn
          fab
          small
          color="white"
          slot="activator"
          :disabled="isLoadingCards"
          @click="listCards"
        >
          <v-icon style="font-size:26px" color="grey darken-1">collections_bookmark</v-icon>
        </v-btn>
        <span>Manejar tarj.</span>
      </v-tooltip>
    </v-speed-dial>

    <show-cards-dialog></show-cards-dialog>
    <show-distributors-dialog></show-distributors-dialog>
    <configure-ftp-dialog></configure-ftp-dialog>
    <distributor-form-dialog></distributor-form-dialog>
    <are-you-sure-dialog></are-you-sure-dialog>
    <show-card-details-dialog></show-card-details-dialog>
    <inconsistencies-report-question-dialog></inconsistencies-report-question-dialog>
    <custom-snack-bar></custom-snack-bar>
  </div>
</template>

<script>
import {filter} from 'lodash'

import eventBus from '../utils/eventBus'
import introBus from '../utils/introBus'

import StrategioAppBar from '../components/header-bar/strategio-app-bar'

import CardsList from '../components/supervisor/cards-list'
import DistributorsDetails from './../components/supervisor/distributors-details'

import supervisorStorage from '../storage/supervisorStorage'
import cardsStorage from '../storage/cardsStorage'
import userStorage from '../storage/userStorage'

import CustomSnackBar from '@/components/snackbars/custom-snack-bar.vue'
import InconsistenciesReportQuestionDialog from '@/components/dialogs/inconsistencies-report-question-dialog.vue'
import DistributorDetailsLogReport from '../components/logs/distributor-details-log-report'
import ShowCardDetailsDialog from '../components/dialogs/show-card-details-dialog'
import ShowCardsDialog from '../components/dialogs/show-cards-dialog'
import ShowDistributorsDialog from '../components/dialogs/show-distributors-dialog'
import ConfigureFtpDialog from '../components/dialogs/configure-ftp-dialog'
import DistributorFormDialog from '../components/dialogs/distributor-form-dialog'
import AreYouSureDialog from '../components/dialogs/are-you-sure-dialog'

export default {
  name: 'supervise-dashboard',
  created () {
    const q = []
    for (let i = 0; i < 1 * 10; i++) {
      q.push(i)
    }
    this.clients = q
    // const w = {
    //   name: 'distribuidor de golosinas',
    //   validator: {
    //     totalLinesInput: 229678,
    //     totalLinesOutput: 229206,
    //     linesNotMatchingColumns: [
    //       {lineNumber: 66413, columns: 16, columnsFound: 17},
    //       {lineNumber: 70456, columns: 16, columnsFound: 17},
    //       {lineNumber: 74268, columns: 16, columnsFound: 17},
    //       {lineNumber: 82615, columns: 16, columnsFound: 17},
    //       {lineNumber: 86577, columns: 16, columnsFound: 17},
    //       {lineNumber: 86650, columns: 16, columnsFound: 17},
    //       {lineNumber: 126628, columns: 16, columnsFound: 17},
    //       {lineNumber: 134055, columns: 16, columnsFound: 17},
    //       {lineNumber: 176232, columns: 16, columnsFound: 17},
    //       {lineNumber: 176233, columns: 16, columnsFound: 17}
    //     ],
    //     linesWithColumnsIssues: [],
    //     linesWithNotMatchingType: []
    //   }
    // }
    // console.log(w)
  },
  data () {
    return {
      search: '',
      cards: [],
      clients: [],
      distributors: [],
      isLoadingDistributors: true,
      isLoadingCards: true,
      fab: false,
      detailedDistributor: {},
      isAdmin: userStorage.getUserInfo().userType === 'ADMIN',

      alert: true
    }
  },
  mounted () {
    supervisorStorage.getRemoteFiles({
      onSuccess: (distributors) => {
        this.distributors = distributors
        this.isLoadingDistributors = false
      },
      onError: (err) => {
        console.warn(err)
      }
    })
    cardsStorage.getCards({
      onSuccess: (cards) => {
        this.cards = cards
        this.isLoadingCards = false
      },
      onError: () => {
        // Mostrar mensaje de error
      }
    })

    eventBus.$off('start-supervise-dashboard-tutorial')
    eventBus.$on('start-supervise-dashboard-tutorial', () => {
      let intro = introBus.getIntroBus()
      intro.addSteps([
        {
          element: '#carditem0',
          intro: 'En estas tarjetas se muestra el estado de los datos que se manejan de las distribuidoras'
        },
        {
          element: '#distributorstate-cards',
          intro: 'Aquí uno puede acceder a más detalles de alguna distribuidora en específico. La información se mostrará en la sección de al lado'
        },
        /* {
          element: '#distributorlog',
          intro: ''
        }, */
        {
          element: '#supervisedashboard-speed-dial',
          intro: 'Con este botón uno podrá administrar las tarjetas disponibles o la información de las distribuidoras'
        }
      ].filter((obj) => {
        return document.getElementById(obj.element.split('#')[1])
      }))

      intro.start()
    })
  },
  methods: {
    listDistributors () {
      // emit to: /components/dialogs/show-distributors-dialog.vue
      eventBus.$emit('open-show-distributors-dialog', this.distributors)
    },
    listCards () {
      // emit to: /components/dialogs/show-cards-dialog.vue
      eventBus.$emit('open-show-cards-dialog', this.cards)
    }
  },
  computed: {
    areCardsDisabled () {
      return filter(this.cards, (card) => card.enabled).length === 0
    }
  },
  watch: {
    isLoadingCards: function (newIsLoadingCards, oldIsLoadingCards) {
      // emits to: /components/header-bar/strategio-app-bar.vue
      if (!this.isLoadingCards && !this.isLoadingDistributors) eventBus.$emit('enable-tutorial-button')
    },
    isLoadingDistributors: function (newIsLoading, oldIsLoading) {
      // emits to: /components/header-bar/strategio-app-bar.vue
      if (!this.isLoadingCards && !this.isLoadingDistributors) eventBus.$emit('enable-tutorial-button')
    }
  },
  components: {
    StrategioAppBar,
    CardsList,
    DistributorsDetails,
    DistributorDetailsLogReport,
    ShowCardDetailsDialog,
    ShowCardsDialog,
    ShowDistributorsDialog,
    ConfigureFtpDialog,
    DistributorFormDialog,
    AreYouSureDialog,
    CustomSnackBar,
    InconsistenciesReportQuestionDialog
  }
}
</script>



// WEBPACK FOOTER //
// src/routes/supervise-dashboard.vue